import React from 'react';
import { isEqual } from 'lodash';

// React view component to render
import { offCallDispositionActivity as OffCallDispositionActivityView } from 'ui/views/widgets/offCallDispositionActivity';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { OffCallDispositionActivityService } from 'services/offCallDispositionActivity';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { OffCallDispositionActivity } from 'ui/containers/OffCallDispositionActivity';
 *
 * // render
 * <OffCallDispositionActivity propName='propValue'/>
 */
export class OffCallDispositionActivity extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // create service instance
        this.offCallDispositionActivityService = new OffCallDispositionActivityService();
        
        // start component data fetch
        this.fetchComponentData( this.props.memberId );
    }

    /*********************************************/

	
	UNSAFE_componentWillReceiveProps ( newProps ) {
        log.debug( 'OffCallDispositionActivityWidget.componentWillReceiveProps()' );
        
		// if `locations` changes, re-render map
		if( ! isEqual( newProps.memberId, this.props.memberId ) ) {
            
            // start component data fetch
			this.fetchComponentData( newProps.memberId ); // re-render map if map dependencies are loaded
		}
	}
    
    /*********************************************/

    /**
     * @desc Fetch component response.
     */
    async fetchComponentData( memberId ) {
        log.debug( 'OffCallDispositionActivityWidget.fetchComponentData()' );

        // cancel ongoing request
        this.offCallDispositionActivityService.cancel();

        // get status and service data
        const { status, data } = await this.offCallDispositionActivityService.fetchComponentData( {
            url: this.props.widget.url,
            data: { memberId: memberId, patientId: this.props.patientId!==undefined?this.props.patientId:'' }
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.offCallDispositionActivityService.cancel(); // cancel ongoing requests
    }

    /*********************************************/

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <OffCallDispositionActivityView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...this.state.componentData }
            />
        );
    }
}

// set display name
OffCallDispositionActivity.displayName = 'OffCallDispositionActivity';

// set default props
OffCallDispositionActivity.defaultProps = {};

// prop types
OffCallDispositionActivity.propTypes = {};
